export const snapPoints = {
    MIN: 'MIN', // Sheet height is the minimum height
    FIT: 'FIT', // Sheet height fits to the content
    MAX: 'MAX'  // Sheet height is of maximum height (height of container element)
};